export default "__VITE_ASSET__D3tiWjOp__"